import { matcherFor, textIsBlocked } from 'lib/chatModeration'

const MATCHES_LIKE_CHAT = 'It matches the way chat overlays do: capitals, accents, look-alike letters from other alphabets, invisible characters, letters spaced out one by one (b a d, b.a.d, b-a-d), repeated letters (baaad) and digits or the signs @ $ ! inside a word do not get around it, a digit or sign at the start or end of a word is read as typed, and words also match inside other words.'
export const WALL_BLOCKED_WORDS_HELP_TWITCH = `One per line, max 100. A chat message whose text or chatter name contains any of these sends no emotes to this wall. ${MATCHES_LIKE_CHAT} An emote's name works like any word: Kappa blocks every message with Kappa. Nothing is blocked unless you list it. A saved list reaches a wall already open in overlay within about a minute.`
export const WALL_BLOCKED_WORDS_HELP_YOUTUBE = `One per line, max 100. A chat message whose text or chatter name contains any of these sends no emoji to this wall. ${MATCHES_LIKE_CHAT} You can also list an emoji or its name, like eggplant, middle finger, fire or thumbs up, and that emoji never shows, in any skin tone. Nothing is blocked unless you list it. A saved change applies to chat read after you save, even on a wall already open in an overlay.`
export const wallBlockedWordsHelpOf = (source: 'TWITCH' | 'YOUTUBE'): string =>
  source === 'YOUTUBE' ? WALL_BLOCKED_WORDS_HELP_YOUTUBE : WALL_BLOCKED_WORDS_HELP_TWITCH

export const YOUTUBE_WALL_SAMPLE_EMOJI_NAMES: Readonly<Record<string, readonly string[]>> = Object.freeze({
  '😂': ['face_with_tears_of_joy', 'joy'],
  '🔥': ['fire'],
  '❤️': ['red_heart', 'heart'],
  '👍': ['thumbs_up', '+1', 'thumbsup'],
  '🎉': ['party_popper', 'tada'],
  '😍': ['smiling_face_with_heart_eyes', 'heart_eyes'],
  '💜': ['purple_heart'],
  '👏': ['clapping_hands', 'clap'],
  '😮': ['face_with_open_mouth', 'open_mouth'],
  '🙌': ['raising_hands', 'raised_hands'],
  '💯': ['hundred_points', '100'],
  '😎': ['smiling_face_with_sunglasses'],
  '🥳': ['partying_face'],
  '✨': ['sparkles'],
  '🤣': ['rolling_on_the_floor_laughing', 'rofl'],
  '👀': ['eyes']
})

const NAME_GAPS = /(?<=[a-z0-9])[-\s]+(?=[a-z0-9])/g
const EDGE_COLONS = /^:+|:+$/g
export const emojiNameKeyOf = (word: string): string =>
  word.trim().replace(EDGE_COLONS, '').toLowerCase().replace(NAME_GAPS, '_')

const STYLE_AND_TONE = /\uFE0E|\uFE0F|\u{1F3FB}|\u{1F3FC}|\u{1F3FD}|\u{1F3FE}|\u{1F3FF}/gu
export const emojiKeyOf = (emoji: string): string => emoji.replace(STYLE_AND_TONE, '')

const EMOJI_SEQUENCE = /\p{Regional_Indicator}{2}|[#*0-9]\uFE0F?\u20E3|\p{Extended_Pictographic}(?:\uFE0F|\p{Emoji_Modifier})*(?:\u200D\p{Extended_Pictographic}(?:\uFE0F|\p{Emoji_Modifier})*)*/gu
const WHITESPACE = /\s+/gu

const emojiOnlyKeysOf = (word: string): string[] => {
  const bare = word.replace(WHITESPACE, '')
  if (bare === '') return []
  const found = bare.match(EMOJI_SEQUENCE) ?? []
  if (found.length === 0 || found.join('') !== bare) return []
  return found.map(emojiKeyOf).filter((k) => k !== '')
}

export const sampleBlockedByList = (words: readonly string[], sample: { name: string, emoji?: string }): boolean => {
  if (words.length === 0) return false
  const matcher = matcherFor(words)
  if (sample.emoji == null) return textIsBlocked(matcher, sample.name)
  if (textIsBlocked(matcher, sample.emoji)) return true
  const names = YOUTUBE_WALL_SAMPLE_EMOJI_NAMES[sample.emoji] ?? []
  const key = emojiKeyOf(sample.emoji)
  return words.some((w) => names.includes(emojiNameKeyOf(w)) || emojiOnlyKeysOf(w).includes(key))
}
